import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Spinner,
  Tip,
  Tag,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
  Video,
  Close,
  View,
} from "grommet-icons";
import axios from "axios";
import { hpe as theme } from "grommet-theme-hpe";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  OnDemandRefreshInterval,
} from "./GlobalSettings";
import DocContentDetail from "./DocContentDetail";

class DocListViewCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      DocContent: this.props._doccontent,
      bShowDocDetail: false,
    };
    this._showDocDetail = this._showDocDetail.bind(this);
    this._hideDocDetail = this._hideDocDetail.bind(this);
  }

  componentDidMount() {}

  _showDocDetail() {
    //console.log("Show dmo Det clicked with data passed as ", data);
    this.setState({ bShowDocDetail: true });
  }
  _hideDocDetail() {
    this.setState({ bShowDocDetail: false });
    this.props.hide();
  }

  render() {
    var DocCont = this.state.DocContent
      ? this.state.DocContent
      : this.props._doccontent;

    var bShowDetailPopup = false;
    bShowDetailPopup = this.state.bShowDocDetail;

    return (
      <Card
        pad="xsmall"
        justify="between"
        height="small"
        background={{ color: "white" }}
      >
        <Box
          align="stretch"
          justify="start"
          direction="row"
          responsive={false}
          pad="xsmall"
          gap="xsmall"
          round="xsmall"
          background={{ opacity: "medium" }}
        >
          <Box align="center" justify="start" direction="column">
            <Text weight="bold" color="black" truncate={false} size="medium">
              {DocCont.Content_Title}
            </Text>
          </Box>
        </Box>
        <Box
          align="stretch"
          justify="between"
          direction="row"
          responsive={false}
          pad="xsmall"
        >
          <Box
            pad="small"
            border={{ color: "brand", size: "small" }}
            round
            alignSelf="start"
          >
            {"Document"}
          </Box>
          <Box
            pad="small"
            border={{ color: "brand", size: "small" }}
            round
            alignSelf="start"
          >
            {DocCont.Content_ExpertiseLevel
              ? DocCont.Content_ExpertiseLevel.ExpertLevelName
              : "No Expertise"}
          </Box>
        </Box>
        <Box
          align="stretch"
          justify="between"
          direction="row"
          responsive={false}
          pad="xsmall"
        >
          <Button label="View" icon={<View />} primary />
        </Box>
      </Card>
    );
  }
}

export default DocListViewCard;
